module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"140424162987087"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
